/* Phone best-selling row. Desktop stays a grid and never binds. */
(() => {
  const PHONE = window.matchMedia("(max-width: 749px)");
  const REDUCED = window.matchMedia("(prefers-reduced-motion: reduce)");

  const bind = (root) => {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll("[data-product-rail]").forEach((rail) => {
      if (rail.dataset.productBound) return;
      rail.dataset.productBound = "true";
      const frame = rail.parentElement;
      if (!frame) return;
      const prev = frame.querySelector("[data-product-prev]");
      const next = frame.querySelector("[data-product-next]");

      const positions = () => {
        const pad = parseFloat(window.getComputedStyle(rail).paddingLeft) || 0;
        const max = Math.max(0, rail.scrollWidth - rail.clientWidth);
        return Array.prototype.map.call(rail.children, (item) => {
          let desired = item.offsetLeft - pad;
          if (desired < 0) desired = 0;
          if (desired > max) desired = max;
          return desired;
        });
      };

      const step = (direction) => {
        if (!PHONE.matches) return;
        const stops = positions();
        if (!stops.length) return;
        const current = rail.scrollLeft;
        let target = current;
        if (direction > 0) {
          target = stops.find((stop) => stop > current + 12);
          if (target == null) target = stops[stops.length - 1];
        } else {
          for (let i = stops.length - 1; i >= 0; i -= 1) {
            if (stops[i] < current - 12) {
              target = stops[i];
              break;
            }
          }
        }
        rail.scrollTo({ left: target, behavior: REDUCED.matches ? "auto" : "smooth" });
      };

      const sync = () => {
        if (!PHONE.matches) {
          if (prev) prev.hidden = true;
          if (next) next.hidden = true;
          return;
        }
        const max = Math.max(0, rail.scrollWidth - rail.clientWidth);
        if (prev) prev.hidden = rail.scrollLeft <= 8;
        if (next) next.hidden = max <= 8 || rail.scrollLeft >= max - 8;
      };

      if (prev) prev.addEventListener("click", () => step(-1));
      if (next) next.addEventListener("click", () => step(1));
      rail.addEventListener("scroll", sync, { passive: true });
      window.addEventListener("resize", sync);
      PHONE.addEventListener("change", sync);
      sync();
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => bind());
  } else {
    bind();
  }
  document.addEventListener("shopify:section:load", (event) => bind(event.target));
})();
